/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { resourceUpdated, selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { changeTopNavigationElements } from "../../slices/navigationPanel/navigationPanelSlice";
import { selectEvidenceTableMap } from "../../slices/evidenceTableMap/evidenceTableMapSlice";
import { selectCurrentUserApiToken, selectSseConnectionId } from "../../slices/currentUser/currentUserSlice";
import { selectAllRelatedResources, selectRelatedResourceCollectionStatus } from "../../slices/relatedResourceCollection/relatedResourceCollectionSlice";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { selectComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import { loadTopSections, selectAllTopSections, selectTopSectionsStatus, topSectionAdded } from "../../slices/topSections/topSectionsSlice";
import getResourceDictionaryFromFoiList from "../../functions/getResourceDictionaryFromFoiListAPI";
import getFhirJson from "../../functions/getFhirJsonAPI";
import jsonEquals from "../../functions/jsonEquals";
import { updateNarrativeElement } from "../../functions/updateElement";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResourceReferenceMap from "../compositionResourceFunctions/loadResourceReferenceMap";
import createEvidenceDisplay from "../compositionResourceFunctions/createEvidenceDisplay";
import { simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import NarrativeEntry, { DisplayFromFHIRXhtml } from "../../datatypeComponents/NarrativeEntry";
import TopSectionSliceDisplay from "./TopSectionSliceDisplay";
import { ReorganizeSectionsModal } from "../ReorderCompositionSections";
import EvidenceTable from "./EvidenceTable";
import Spinner from "../../components/Spinner";

const generateNarrativeFromEvidenceTable = (resourceReferenceMap, resourceJson) => {
    let innerDiv = "";
    if (resourceReferenceMap.groupReferencesDictionary && resourceJson.section?.length > 0) {
        const groupKeys = Object.keys(resourceReferenceMap.groupReferencesDictionary) || [];
        if (groupKeys.length > 0) {
            const combinedDictionary = resourceReferenceMap.combinedDictionary;
            let sortedSections = JSON.parse(JSON.stringify(resourceJson.section)).sort();
            innerDiv = "<table><tr><th>Variable Name</th>";
            for (const groupKey of groupKeys) {
                if (resourceReferenceMap.groupReferencesDictionary[groupKey]) {
                    innerDiv += "<th>" + resourceReferenceMap.groupReferencesDictionary[groupKey].display + "</th>";
                } else {
                    innerDiv += "<th>Can't access Referenced Group</th>";
                }
            }
            innerDiv += "</tr>";
            for (const section of sortedSections) {
                if (section?.code?.coding?.[0]?.code === "results") {
                    let evidenceForGroupDictionary = {};
                    if (section.entry?.length > 0) {
                        for (let entry of section.entry) {
                            let evidenceId = getIdFromReference(entry);
                            const Evidence = combinedDictionary[evidenceId]; //Evidence Resource JSON
                            if (Evidence) {
                                let groupReference = Evidence.variableDefinition?.[0].observed || Evidence.variableDefinition?.[0].intended;
                                if (Evidence.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" ||
                                    Evidence.variableDefinition?.[1]?.variableRole === "exposure"
                                ) {
                                    groupReference = Evidence.variableDefinition?.[1]?.observed || Evidence.variableDefinition?.[1]?.intended;
                                }
                                let groupReferenceId = getIdFromReference(groupReference);
                                evidenceForGroupDictionary[groupReferenceId] = evidenceId;
                            }
                        }
                    }
                    innerDiv += "<tr>";
                    innerDiv += "<td>" + (section.title || section.focus?.display) + "</td>";
                    for (const grKey of groupKeys) {
                        const evidenceId = evidenceForGroupDictionary[grKey];
                        const EvidenceJson = combinedDictionary[evidenceId];
                        innerDiv += "<td>";
                        if (evidenceId && createEvidenceDisplay(EvidenceJson)) {
                            innerDiv += "<p>" + createEvidenceDisplay(EvidenceJson) + "</p>";
                        } else {
                            innerDiv += "<p>[No data.]</p>";
                        }
                        innerDiv += "</td>";
                    }
                    innerDiv += "</tr>";
                }
            }
            innerDiv += "</table>";
        } else {
            innerDiv = "<p>A technical error has occurred</p>";
        }
    } else {
        innerDiv = "<p>There are no results sections to produce an evidence table.</p>";
    }
    return {
        "status": "generated",
        "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + innerDiv + "</div>"
    };
};

const loadAssociatedOutcomeMeasureReport = async (outcomeMeasuresReportReference,
    setAssociatedOutcomeMeasureReportState, apiToken, connectionId = null) => {
    let omrFoi = getIdFromReference(outcomeMeasuresReportReference);
    let omrJson;
    let omrDictionary;
    console.log(omrFoi)
    if (omrFoi && !isNaN(omrFoi)) {
        omrJson = await getFhirJson(omrFoi, null, apiToken, false);
        console.log(omrJson)
        let foiList = [];
        if (omrJson.section) {
            for (const section of omrJson.section) {
                if (section.focus) {
                    foiList.push(getIdFromReference(section.focus));
                }
                if (section.entry?.length > 0) {
                    for (const entry of section.entry) {
                        foiList.push(getIdFromReference(entry));
                    }
                }
                if (section.section?.length > 0) {
                    for (const subsection of section.section) {
                        if (subsection.focus) {
                            foiList.push(getIdFromReference(subsection.focus));
                        }
                        if (subsection.entry?.length > 0) {
                            for (const entry of subsection.entry) {
                                foiList.push(getIdFromReference(entry));
                            }
                        }
                        if (subsection.section?.length > 0) {
                            for (const subsubsection of subsection.section) {
                                if (subsubsection.focus) {
                                    foiList.push(getIdFromReference(subsubsection.focus));
                                }
                                if (subsubsection.entry?.length > 0) {
                                    for (const entry of subsubsection.entry) {
                                        foiList.push(getIdFromReference(entry));
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        console.log(JSON.stringify(foiList))
        let omrDictionaryResponse = await getResourceDictionaryFromFoiList(apiToken, connectionId, foiList, null); //TODO TO DO, shouldn't we set connectionId here to null? Unless we do want to get an alert if one of the resources changes in another session.
        console.log(omrDictionaryResponse)
        if (omrDictionaryResponse?.success && omrDictionaryResponse.resourceDictionary) {
            omrDictionary = omrDictionaryResponse.resourceDictionary;
            if (Array.isArray(omrJson.contained) && omrJson.contained.length > 0) {
                for (const item of omrJson.contained) {
                    omrDictionary[item.id] = item;
                }
            }
        }
    }
    setAssociatedOutcomeMeasureReportState({ "foi": omrFoi, "json": omrJson, "resourceDictionary": omrDictionary });
};

const MappedEvidenceReportDisplay = ({ foi, relatedOutcomeMeasureReportFoi, triggerReload, setTriggerReload }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const apiToken = useSelector(selectCurrentUserApiToken);
    const connectionId = useSelector(selectSseConnectionId);
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const resourceCollection = useSelector(state => selectAllResources(state));
    const relatedResourceCollection = useSelector(state => selectAllRelatedResources(state));
    const relatedResourceCollectionStatus = useSelector(selectRelatedResourceCollectionStatus);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));
    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const evidenceTableMap = useSelector(selectEvidenceTableMap);
    const allTopSections = useSelector(selectAllTopSections);
    const topSectionsStatus = useSelector(selectTopSectionsStatus);
    const relatedResourceCollectionLoaded = useSelector(selectRelatedResourceCollectionStatus);

    let isEvidenceReportProfile;
    let isEvidenceReportPackageProfile;
    let isComparativeEvidenceReportProfile;
    let isComparativeEvidenceSynthesisReportProfile;
    let isBaselineMeasureReportProfile;
    let isParticipantFlowReportProfile;
    let isOutcomeMeasureReportProfile;

    if (resourceJson.meta?.profile?.length) {
        for (const profile of resourceJson.meta.profile) {
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report") {
                isEvidenceReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/baseline-measure-report") {
                isEvidenceReportProfile = true;
                isBaselineMeasureReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-measure-report" ||
                profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/adverse-events-report"
            ) {
                isEvidenceReportProfile = true;
                isOutcomeMeasureReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-report") {
                isEvidenceReportProfile = true;
                isParticipantFlowReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report-package") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-report") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isComparativeEvidenceReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-synthesis-report") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isComparativeEvidenceSynthesisReportProfile = true;
            }
        }
    }
    let reportType = isOutcomeMeasureReportProfile ? "Outcome Measure Report" :
        isParticipantFlowReportProfile ? "Participant Flow Report" :
            isBaselineMeasureReportProfile ? "Baseline Measure Report" : "";

    const [compositionResourceState, setCompositionResourceState] = useState({});
    const [editSectionModal, setEditSectionModal] = useState({ "openModal": false });
    const [sectionNavigationElementIds, setSectionNavigationElementIds] = useState([]);
    const [sectionsReorganizedState, setSectionsReorganizedState] = useState({});
    const [addSectionState, setAddSectionState] = useState({
        "sectionTitle": "", "addSectionClicked": false
    });
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState("");
    const [associatedOutcomeMeasureReportState, setAssociatedOutcomeMeasureReportState] = useState({
        "foi": "", "json": "", "resourceDictionary": ""
    });
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useEffect(() => {
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setCompositionResourceState(olderVersionJson);

                let topNavigationElements = [];

                if (isOutcomeMeasureReportProfile || isParticipantFlowReportProfile || isBaselineMeasureReportProfile) {
                    topNavigationElements.push("Summary");
                    topNavigationElements.push("Evidence Table");
                }
                let sectionHeaderNavigationElements = [];
                if (Array.isArray(olderVersionJson.section)) {
                    for (const section of olderVersionJson.section) {
                        let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                        let sectionFocus = section?.focus?.display || section?.focus?.reference;
                        let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                        topNavigationElements.push(sectionHeader);
                        sectionHeaderNavigationElements.push(sectionHeader);
                    }
                }
                dispatch(changeTopNavigationElements(topNavigationElements));

                const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                    let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                    return id;
                }))
                setSectionNavigationElementIds(sectionNavigationIds);
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson?.id) {
            setCompositionResourceState(resourceJson);
            setSectionsReorganizedState({ "reorganized": false, "section": resourceJson.section });

            let topNavigationElements = [];

            if (isOutcomeMeasureReportProfile || isParticipantFlowReportProfile || isBaselineMeasureReportProfile) {
                topNavigationElements.push("Summary");
                topNavigationElements.push("Evidence Table");
            }
            let sectionHeaderNavigationElements = [];
            if (Array.isArray(resourceJson.section)) {
                for (const section of resourceJson.section) {
                    let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                    let sectionFocus = section?.focus?.display || section?.focus?.reference;
                    let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                    topNavigationElements.push(sectionHeader);
                    sectionHeaderNavigationElements.push(sectionHeader);
                }
            }
            dispatch(changeTopNavigationElements(topNavigationElements));

            if (Array.isArray(resourceJson.contained) && resourceJson.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of resourceJson.contained) {
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
            const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                return id;
            }));
            setSectionNavigationElementIds(sectionNavigationIds);
            loadResourceReferenceMap(dispatch, resourceJson, foi,
                parentResourceDetail, resourceCollection,
                isBaselineMeasureReportProfile, isParticipantFlowReportProfile, isOutcomeMeasureReportProfile,
                isComparativeEvidenceReportProfile, isComparativeEvidenceSynthesisReportProfile,
                relatedResourceCollection, relatedOutcomeMeasureReportFoi
            )
            if (triggerReload === true) {
                setTriggerReload(false);
            }
        }
    }, [resourceJson, resourceCollection, triggerReload, relatedResourceCollectionStatus]);

    useEffect(() => {
        if (comparativeEvidenceMap?.outcomeMeasuresReportReference &&
            relatedResourceCollectionLoaded === "succeeded") {
            loadAssociatedOutcomeMeasureReport(comparativeEvidenceMap.outcomeMeasuresReportReference,
                setAssociatedOutcomeMeasureReportState, apiToken, connectionId);
        }
    }, [comparativeEvidenceMap, relatedResourceCollectionLoaded]);

    useEffect(() => {
        if (reportType && evidenceTableMap?.groupReferencesDictionary) {
            let generatedNarrative = generateNarrativeFromEvidenceTable(evidenceTableMap, resourceJson);
            setGeneratedNarrativeState(generatedNarrative);
        }
    }, [evidenceTableMap]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateNarrativeElement(compositionResourceState, "text", parentResourceDetail,
                dispatch);
        }
    }, [compositionResourceState.text]);

    useEffect(() => {
        if (topSectionsStatus === "succeeded" && editMode && resourceJson && allTopSections?.length > 0 &&
            (parentResourceDetail?.resourceJson?.section || allTopSections.length !== 1 || allTopSections[0]?.revisedSection)) {
            const newCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (!jsonEquals(parentResourceDetail.revisedResourceJson.section, newCompositionSection)) {
                console.log("resourceUpdate for Composition.section");
                let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
                newResourceDetail.revisedResourceJson.section = newCompositionSection;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [allTopSections]);

    useEffect(() => {
        if (editMode && resourceJson && addSectionState.addSectionClicked &&
            addSectionState.sectionTitle) {
            let sectionLength = allTopSections.length;
            let sectionBody = {
                id: sectionLength,
                displayTitle: addSectionState.sectionTitle,
                compositionId: foi,
                productFamily: parentResourceDetail.productFamily,
                initialSection: { "title": addSectionState.sectionTitle },
                revisedSection: { "title": addSectionState.sectionTitle }
            }
            dispatch(topSectionAdded(sectionBody));
            console.log("addSectionState so resourceUpdate for Composition.section");
            setAddSectionState({
                "sectionTitle": "", "addSectionClicked": false
            });
        }
    }, [addSectionState]);

    useEffect(() => {
        if (editMode && resourceJson && sectionsReorganizedState.reorganized &&
            Array.isArray(sectionsReorganizedState.section) && sectionsReorganizedState.section.length > 0) {
            setSectionsReorganizedState(prevState => { return { ...prevState, "reorganized": false } });
            let oldCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (!jsonEquals(oldCompositionSection, sectionsReorganizedState.section)) {
                let topSectionArray = sectionsReorganizedState.section.map((section, sectionIndex) => {
                    return {
                        id: sectionIndex,
                        displayTitle: section.title ||
                            simpleDisplayStringFromFHIRCodeableConcept(section.code) ||
                            displayStringFromFHIRReference(section.focus) || "Untitled Section",
                        compositionId: foi,
                        productFamily: parentResourceDetail.productFamily,
                        initialSection: section,
                        revisedSection: section
                    };
                });
                let topSectionsBody = { topSections: topSectionArray };
                dispatch(loadTopSections(topSectionsBody));
                console.log("sectionsReorganized so resourceUpdate for Composition.section");
            }
        }
    }, [sectionsReorganizedState]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <>
        {compositionResourceState.id && <>
            <div style={{ marginTop: "12px" }}>
                {
                    (isOutcomeMeasureReportProfile || isParticipantFlowReportProfile || isBaselineMeasureReportProfile) &&
                    <div>
                        <h3 id="summary">Summary</h3>
                        <div style={{ marginLeft: "24px" }}>
                            {
                                editMode ?
                                    <>
                                        <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                                            generatedNarrative={generatedNarrativeState} startCollapsed
                                            startingValue={compositionResourceState.text}
                                            setResourceState={setCompositionResourceState} />
                                    </>
                                    :
                                    <>
                                        {(compositionResourceState.text?.div && compositionResourceState.text.status && compositionResourceState.text.status !== "empty") ?
                                            <DisplayFromFHIRXhtml xhtml={compositionResourceState.text.div} />
                                            : <p>[Narrative summary not generated.]</p>}
                                    </>
                            }
                        </div>
                        <EvidenceTable foi={foi}
                            reportType={reportType} containedResourceDictionary={containedResourceDictionary}
                            populationGroup={comparativeEvidenceMap?.populationReference || { "display": "the study group" }}
                            synthesisPopulationGroup={comparativeEvidenceMap?.synthesisPopulationReference || compositionResourceState?.subject?.[0]} />
                    </div>
                }
                {editMode && <div>
                    <Button className="formButton" style={{ margin: "0px", /*color: "#000000", */ }}
                        content="Reorganize Sections" compact
                        onClick={() => { setEditSectionModal({ "openModal": true }) }} />
                    <br />
                </div>}
                {(editSectionModal.openModal) &&
                    <>
                        <ReorganizeSectionsModal
                            editSectionModal={editSectionModal}
                            setEditSectionModal={setEditSectionModal}
                            sectionsReorganizedState={sectionsReorganizedState}
                            setSectionsReorganizedState={setSectionsReorganizedState}
                        />
                    </>}
                {(compositionResourceState.section?.length > 0) &&
                    compositionResourceState.section.map((section, sectionIndex) => {
                        return <div key={sectionIndex}>
                            <TopSectionSliceDisplay foi={foi}
                                setCompositionResourceState={setCompositionResourceState}
                                sectionIndex={sectionIndex} containedResourceDictionary={containedResourceDictionary}
                                resourceReferenceMap={comparativeEvidenceMap}
                                sectionNavigationElementIds={sectionNavigationElementIds}
                                associatedOutcomeMeasureReportState={associatedOutcomeMeasureReportState} />
                            <br />
                        </div>
                    })}
                {editMode &&
                    <>
                        <Button style={{ color: "#000000", width: "130px", float: "left" }}
                            className="formButton"
                            content="+ Add Section"
                            onClick={() => {
                                setAddSectionState({
                                    "sectionTitle": "Replace with Proper Section Title",
                                    "addSectionClicked": true
                                });
                            }}
                        />
                    </>}
            </div>
        </>}
    </>
}

export default MappedEvidenceReportDisplay;